var synHeader = {};

(function(exports) {
  exports.handleStickyHeaderScroll = function() {
    const body = document.querySelector('body');
    const siteHeader = document.querySelector('.site-header');
    
    if (body.classList.contains('sticky-header')) {
      if (window.scrollY <= siteHeader.offsetHeight) {
        body.classList.remove('sticky-header');
      }
    } else {
      if (window.scrollY >= siteHeader.offsetHeight) {
        body.classList.add('sticky-header');
      }
    }
  };
})(synHeader);